"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { onCatalogView, onLiveCatalogProduct } from "../../redux/homeAction";
import { useDispatch, useSelector } from "react-redux";

export default function CatalogDetailPage({ params }) {
  const dispatch = useDispatch();
  const { id } = useParams(); // ✅ THIS IS THE FIX
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const getOnCatalogView = useSelector((state) => state.home.getOnCatalogView);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    dispatch(onCatalogView(id, setLoading));
  }, [id]);

  if (loading) {
    return <div className="p-10 text-center text-gray-500">Loading...</div>;
  }

  if (!getOnCatalogView) {
    return <div className="p-10 text-center text-red-500">No data Found</div>;
  }

  const onProductLiveHandler = () => {
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    dispatch(onLiveCatalogProduct(id, setLoading, navigate));
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  return (
    <>
      {showConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 animate-fadeIn">
          <div className="w-[90%] max-w-md rounded-2xl bg-white p-6 shadow-xl">
            <h2 className="text-lg font-semibold text-gray-800">
              Confirm Action
            </h2>

            <p className="mt-2 text-sm text-gray-600">
              Are you sure you want to make this product live?
            </p>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={handleCancel}
                className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Cancel
              </button>

              <button
                onClick={handleConfirm}
                className="rounded-lg bg-green-600 px-4 py-2 text-sm text-white hover:bg-green-700"
              >
                Yes, Make Live
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="min-h-screen bg-gray-100 flex flex-col lg:flex-row gap-6 p-4 lg:p-6 pb-24">
        {/* LEFT SIDEBAR (STICKY SUMMARY) */}
        <div className="w-full lg:w-[300px] bg-white rounded-2xl shadow p-5 h-fit lg:sticky lg:top-6">
          <h2 className="text-xl font-bold mb-4">📦 Catalog Summary</h2>

          <div className="space-y-2 text-sm">
            <p>
              <b>Status:</b> {getOnCatalogView?.status}
            </p>
            <p>
              <b>Category:</b> {getOnCatalogView?.category?.name}
            </p>
            <p>
              <b>Products:</b> {getOnCatalogView?.products?.length}
            </p>
            <p>
              <b>Created:</b>{" "}
              {new Date(getOnCatalogView?.createdAt)?.toLocaleString()}
            </p>
          </div>

          <div className="mt-4 p-3 bg-gray-50 rounded-lg text-xs text-gray-500">
            ID: {getOnCatalogView?._id}
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="flex-1 space-y-6">
          {/* HEADER CARD */}
          <div className="bg-white p-6 rounded-2xl shadow">
            <h1 className="text-2xl font-bold">
              {getOnCatalogView?.category?.name} Catalog Draft
            </h1>
            <p className="text-gray-500 mt-1">
              Complete product listing with variants, images & sizes
            </p>
          </div>

          {/* PRODUCTS */}
          {getOnCatalogView?.products?.map((p, index) => (
            <div
              key={p._id}
              className="bg-white p-6 rounded-2xl shadow space-y-4"
            >
              {/* PRODUCT HEADER */}
              <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-2">
                <h2 className="text-lg font-semibold">
                  {index + 1}. {p.name}
                </h2>

                <span className="px-3 py-1 text-xs rounded-full bg-yellow-100 text-yellow-700">
                  {p.color}
                </span>
              </div>

              {/* EXTRA ATTRIBUTES */}

              {/* DETAILS GRID */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 text-sm text-gray-700">
                <p>
                  <b>weight (grams) :</b> {p.weight}
                </p>
                <p>
                  <b>Fabric:</b> {p.fabric}
                </p>
                <p>
                  <b>Fit:</b> {p.fitShape}
                </p>
                <p>
                  <b>Pattern:</b> {p.pattern}
                </p>
                <p>
                  <b>Type:</b> {p.printOrPatternType}
                </p>
                <p>
                  <b>Occasion:</b> {p.occasion}
                </p>
                <p>
                  <b>Country:</b> {p.countryOfOrigin}
                </p>
                <p>
                  <b>Wash Care:</b> {p.washCare}
                </p>

                <p>
                  <b>Model Height:</b> {p.modelHeight}
                </p>
                <p>
                  <b>Model Size:</b> {p.modelWearingSize}
                </p>

                <p>
                  <b>Is Set:</b> {p.isSet ? "Yes" : "No"}
                </p>
                <p>
                  <b>Set Items:</b> {p.setItemsCount}
                </p>
                <p>
                  <b>Included Items:</b> {p.includedItems?.join(", ")}
                </p>

                <p>
                  <b>Return Allowed:</b> {p.returnAllowed ? "Yes" : "No"}
                </p>
                <p>
                  <b>Return Days:</b> {p.returnDays}
                </p>

                <p>
                  <b>Refund Allowed:</b> {p.refundAllowed ? "Yes" : "No"}
                </p>
                <p>
                  <b>Exchange Allowed:</b> {p.exchangeAllowed ? "Yes" : "No"}
                </p>
              </div>

              {/* DESCRIPTION */}
              <p className="text-gray-600 text-sm">{p.description}</p>

              {/* IMAGES */}
              <div>
                <h3 className="font-semibold mb-2">Images</h3>

                <div className="flex gap-3 flex-wrap justify-start">
                  {p.images
                    ?.filter((img) => img.urls)
                    .map((img) => (
                      <div key={img._id} className="text-center">
                        {/* IMAGE */}
                        <img
                          src={img.urls?.original}
                          onClick={() => setSelectedImage(img.url)}
                          className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded-lg border cursor-pointer hover:scale-105 transition"
                        />

                        {/* TYPE LABEL */}
                        <p className="text-xs mt-1 text-gray-600 capitalize">
                          {img.type}
                        </p>
                      </div>
                    ))}
                </div>
              </div>

              {/* SIZES */}
              {/* <div>
              <h3 className="font-semibold mb-2">Size Variants</h3>

              <div className="flex flex-wrap gap-2">
                {p.sizes.map((size) => (
                  <div
                    key={size._id}
                    className="px-3 py-1 text-xs border rounded-lg bg-gray-50"
                  >
                    {size.size} | ₹{size.price} | Stock: {size.inventory}
                  </div>
                ))}
              </div>
            </div> */}

              <div>
                <h3 className="font-semibold mb-3">Size Details</h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {p.sizes?.map((size) => (
                    <div
                      key={size._id}
                      className="border rounded-xl p-3 bg-gray-50 hover:bg-gray-100 transition"
                    >
                      {/* SIZE HEADER */}
                      <div className="flex justify-between items-center mb-2">
                        <span className="font-bold text-lg">{size.size}</span>
                        <span className="text-green-600 font-semibold">
                          ₹{size.price}
                        </span>
                      </div>

                      {/* PRICE INFO */}
                      <div className="text-sm text-gray-700 space-y-1">
                        <p>MRP: ₹{size.mrp}</p>
                        <p>Inventory: {size.inventory}</p>
                      </div>

                      {/* MEASUREMENTS */}
                      <div className="mt-2 grid grid-cols-2 gap-1 text-xs text-gray-600">
                        <p>Bust: {size.bust}</p>
                        <p>Shoulder: {size.shoulder}</p>
                        <p>Waist: {size.waist}</p>
                        <p>Length: {size.length}</p>
                        <p>Hip: {size.hip}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedImage && (
          <div
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
            onClick={() => setSelectedImage(null)} // click outside to close
          >
            <img
              src={selectedImage}
              className="max-w-[90%] max-h-[90%] rounded-lg shadow-2xl"
            />

            {/* CLOSE BUTTON */}
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-5 right-5 text-white text-2xl"
            >
              ✕
            </button>
          </div>
        )}
      </div>
      {/* ACTION BAR */}
      <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur border-t shadow-md p-2 flex gap-2 z-50">
        {/* EDIT */}
        <button
          className="flex-1 py-2.5 rounded-lg border text-sm font-medium text-gray-700 hover:bg-gray-100 transition"
          onClick={() => navigate(`/catalog/edit/${id}`)}
        >
          ✏️ Edit
        </button>

        {/* LIVE */}
        <button
          className="flex-1 py-2.5 rounded-lg bg-green-600 text-white text-sm font-medium hover:bg-green-700 transition"
          onClick={onProductLiveHandler}
        >
          🚀 Live
        </button>

        {/* REJECT */}
        <button
          className="flex-1 py-2.5 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700 transition"
          onClick={() => console.log("Reject clicked")}
        >
          ❌ Reject
        </button>
      </div>
    </>
  );
}
